import React from 'react';
import ReportingFinancesChargebacksPage from '../components/ReportingFinancesChargebacksPage';

const ReportingFinancesChargebacksApp = (props) => (
  <ReportingFinancesChargebacksPage {...props} />
);

export default ReportingFinancesChargebacksApp;
